import React from 'react';

import LockboxInfoContainer from '@/modules/employer/components/Lockbox/LockboxDetails/components/LockboxInfo/LockboxInfoContainer';
import { useLockboxRecordFields } from '@/modules/employer/components/Lockbox/LockboxDetails/hooks';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';
import useGetVendorsQuery from '@/modules/employer/components/Lockbox/queries/useGetVendors.query';

import LockboxForm from './components/LockboxForm';

const LockboxRecordForm = () => {
  const { isEditMode, isDividingMode } = useLockboxDetailsStore();
  const { vendors } = useGetVendorsQuery();
  const { lockboxRecordFields } = useLockboxRecordFields({ vendors });

  if (isDividingMode) {
    return null;
  }

  return (
    <LockboxInfoContainer data-testid="lockbox-record-form">
      <LockboxForm fields={lockboxRecordFields} isEditMode={isEditMode} />
    </LockboxInfoContainer>
  );
};

export default LockboxRecordForm;
